import { render, staticRenderFns } from "./toggleDesc.vue?vue&type=template&id=d40d7e42&scoped=true"
import script from "./toggleDesc.vue?vue&type=script&lang=js"
export * from "./toggleDesc.vue?vue&type=script&lang=js"
import style0 from "./toggleDesc.vue?vue&type=style&index=0&id=d40d7e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40d7e42",
  null
  
)

export default component.exports